//@flow
import * as React from 'react';
import { styled } from 'linaria/react';
import { createStore, createEvent, type Store, type Event } from 'effector';
import { createComponent, type StoreView } from 'effector-react';
export function Toggle({
  name,
  checked,
  onChange
}: {
  name: string,
  checked: boolean,
  onChange: (e: SyntheticEvent<HTMLInputElement>) => mixed,
}) {
  return <Input type="checkbox" checked={checked} onChange={onChange} name={name} />;
}
Toggle.defaultProps = {
  checked: false,

  onChange() {}

};
const Input =
/*#__PURE__*/
styled("input")({
  name: "Input",
  class: "i1n0qkax"
});